// constants
import { ImportactionTypes } from './constants';

export type ImportactionType = {
    type:
        | ImportactionTypes.API_RESPONSE_SUCCESS
        | ImportactionTypes.API_RESPONSE_ERROR
        | ImportactionTypes.IMPORT_ALL
        | ImportactionTypes.RESET
        | ImportactionTypes.RESET_SUCCESS
        | ImportactionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const importApiResponseSuccess = (
    actionType: string,
    data: [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ImportactionType => ({
    type: ImportactionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const importApiResponseError = (
    actionType: string,
    data: [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ImportactionType => ({
    type: ImportactionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const allImport = (params: any): ImportactionType => ({
    type: ImportactionTypes.IMPORT_ALL,
    payload: params,
});

export const resetImport = (): ImportactionType => ({
    type: ImportactionTypes.RESET,
    payload: {},
});

export const resetImportSuccess = (): ImportactionType => ({
    type: ImportactionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetImportError = (): ImportactionType => ({
    type: ImportactionTypes.RESET_ERROR,
    payload: {},
});
